import React, { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useStaticOptions } from "../context/StaticOptionsContext";

const szinKategoriak = [
	{ kategoria: "Ráma színe", key: "rama_szin" },
	{ kategoria: "Köztalp színe", key: "koztalp_szin" },
	{ kategoria: "Talp színe", key: "talp_szin" }
];


const TalpRamaSzine = () => {
	const { order, updateOrder } = useOrder();
	const navigate = useStepNavigate();

	const [talpSzin, setTalpSzin] = useState(order.talp_szin || "");
	const [ramaSzin, setRamaSzin] = useState(order.rama_szin || "");
	const [koztalpSzin, setKoztalpSzin] = useState(order.koztalp_szin || "");
	const { staticOptions } = useStaticOptions();
	const rama_colors = staticOptions?.rama_colors || [];
	

	// const [shoe_colors, setShoeColors] = useState([]);


	const handleSelection = (groupKey, color) => {
		if (groupKey === "talp_szin") {
			setTalpSzin(color.value);
			updateOrder({
				...order,
				talp_szin: color.value,
				talp_szin_name: color.label
			});
		} else if (groupKey === "rama_szin") {
			setRamaSzin(color.value);
			updateOrder({
				...order,
				rama_szin: color.value,
				rama_szin_name: color.label
			});
		} else if (groupKey === "koztalp_szin") {
			setKoztalpSzin(color.value);
			updateOrder({
				...order,
				koztalp_szin: color.value,
				koztalp_szin_name: color.label
			});
		}
	};

	const handleBack = () => {
		navigate("/Rama");
	};

	const handleNext = () => {
		navigate("/BelesTipus");
	};

	const canProceed = talpSzin && ramaSzin && koztalpSzin;


	return (
		<TablerLayout title="Válassza ki a ráma, köztalp és talp színét!">
			<div className="row justify-content-center">
				<div className="col-md-10">
						<div className="card-body">
							<div className="row g-4">
								{szinKategoriak.map((kategoria) => {
									let selectedValue = "";
									if (kategoria.key === "talp_szin") selectedValue = talpSzin;
									if (kategoria.key === "rama_szin") selectedValue = ramaSzin;
									if (kategoria.key === "koztalp_szin") selectedValue = koztalpSzin;

									return (
										<div className="col-12 col-md-4" key={kategoria.kategoria}>
											<div className="mb-3 fw-bold text-center fs-5">{kategoria.kategoria}</div>
											<ul className="list-unstyled d-flex flex-column gap-3 align-items-center">
												{rama_colors.map((szin) => {
													const colorValue = szin.value.toString();
													const colorName = szin.label;
													
													return (
														<li key={colorValue} className="w-100">
															<button
																type="button"
																className={`btn w-100 py-3 px-3 shadow-sm rounded-4 d-flex align-items-center justify-content-center 
																	${selectedValue === colorValue 
																		? "btn-primary text-white" 
																		: "btn-outline-primary border-primary"}`}
																style={{
																	fontSize: 16,
																	fontWeight: 600,
																	borderWidth: 2,
																}}
																onClick={() => handleSelection(kategoria.key, {
																	value: colorValue,
																	label: colorName
																})}
															>
																{colorName.split(' ')[0]}
															</button>
														</li>
													);
												})}
											</ul>
										</div>
									);
								})}
							</div>
						</div>
						<div className="card-footer d-flex justify-content-between">
							<StepperNavButton side="left" label="Vissza" onClick={handleBack} />
							<StepperNavButton side="right" label="Tovább" onClick={handleNext} disabled={!canProceed} />
						</div>
				</div>
			</div>
		</TablerLayout>
	);
};

export default TalpRamaSzine;
